import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Shared axios instance for the admin back-office.
 * - Request interceptor: automatically attaches the Bearer token from localStorage
 *   so individual components don't have to pass `getAuthHeaders()`.
 * - Response interceptor: on 401 (token invalid/expired), clears the local session
 *   and redirects the user to the login screen.
 */
const adminApi = axios.create({
  baseURL: API
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = !!localStorage.getItem('admin_token');
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      // Only force a redirect if the user *was* logged in — avoids loops on the login page.
      if (hadToken && typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

export { adminApi, API, BACKEND_URL };
export default adminApi;
